// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"38f5bae1","160":"c3804aa2","208":"28b1896f","293":"70df8720","516":"cebeba2e","519":"839a0131","917":"f3123a0b","946":"9f5029bf"}[chunkId] + ".chunk.js";
};